// src/stone/icons/CheckCircle.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var CheckCircle = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    className: "check-circle_svg__mt-4 check-circle_svg__mr-16 check-circle_svg__w-24 check-circle_svg__min-w-[24px] check-circle_svg__h-24 check-circle_svg__min-h-[24px] check-circle_svg__text-stone-500 check-circle_svg__fill-current",
    viewBox: "0 0 24 24",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M15.663 3.773A9 9 0 1 0 21 12v-.919a1 1 0 1 1 2 0V12A11.002 11.002 0 0 1 8.188 22.313a11 11 0 1 1 8.289-20.366 1 1 0 1 1-.814 1.826",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M22.707 3.293a1 1 0 0 1 0 1.414l-10 10.01a1 1 0 0 1-1.414 0l-3-3a1 1 0 1 1 1.414-1.414L12 12.595l9.293-9.302a1 1 0 0 1 1.414 0",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
var CheckCircle_default = CheckCircle;

export {
  CheckCircle_default
};
